import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_shipment_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_shipment_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_shipment_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "required" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "required" }
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_24 = {
  type: "submit",
  id: "kt_shipment_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = { class: "indicator-progress" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PackagesListing = _resolveComponent("PackagesListing")!
  const _component_PackagesCreating = _resolveComponent("PackagesCreating")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'hubs-shipments'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('shipmentDetails')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.shipmentsSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate('area')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "areaId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedAreas,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAreas) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.translate('selectArea')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: area.id,
                              value: area.id
                            }, _toDisplayString(area.titleTranslate), 9, _hoisted_12))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "areaId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('shipmentStatuses')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "statusId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectStatus,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectStatus) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.translate('selectStatus')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentStatuses, (shipmentStatus) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: shipmentStatus.id,
                              value: shipmentStatus.id
                            }, _toDisplayString(shipmentStatus.internal[1].title), 9, _hoisted_20))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_ErrorMessage, { name: "statusId" })
                        ])
                      ])
                    ])
                  ])
                ]),
                (!_ctx.createdShipment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      _createElementVNode("button", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_26, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_27
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PackagesListing, { "created-shipment": _ctx.createdShipment }, null, 8, ["created-shipment"]),
    (_ctx.createdShipment)
      ? (_openBlock(), _createBlock(_component_PackagesCreating, {
          key: 1,
          "shipment-id": _ctx.createdShipment.id
        }, null, 8, ["shipment-id"]))
      : _createCommentVNode("", true)
  ], 64))
}